import React, { useEffect, useState } from "react";
import { getAxiosResponse, downloadFile } from "../../../services/authApiRoutes/APImethods";
import APIUrls from "../../../services/APIUrls";
import { RotatingLines } from "react-loader-spinner";
import Constants from "../../../Constants";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import $ from "jquery";
import { handleError } from "../../../services/authApiRoutes/APImethods";
import { alphabeticalSortingLanguage, dateFormat } from "../../../services/Util";

export default function Reviewers() {
  const { t } = useTranslation();
  const translate = t;
  const param = useParams();
  const workspaceId = param.id;
  const [loader, setLoader] = useState(true);
  const [overViewData, setOverviewData] = useState([]);
  const [latestUpdateTime, setUpdateTime] = useState([]);
  const [reviewListData, setReviewListData] = useState([]);
  const [totalOpenReviewerCount, setOpenReviewerCount] = useState(0);
  const [totalNotStartedReviewerCount, setNotStartedReviewerCount] = useState(0);
  const [totalCompletedReviewerCount, setCompletedReviewerCount] = useState(0);
  const [totalEditCount, setEditCount] = useState(0);
  const [totalCommentCount, setCommentCount] = useState(0);
  const [reviewerStatus,setReviewerStatus]=useState(false)
  const refreshPage = () =>{
    getData();
  }
  const downloadReport = () =>{
    downloadFile(APIUrls.DOWNLOAD_REVIEWER_REPORT+`?workspaceId=${workspaceId}`,'Reviewer_Status.xlsx').then().catch(err=>{
      console.error(err)
    }) ; 
  }
  $(document).mouseup(function(e) {
    var bannerCont = $('.lang-table');
    if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
      $('.tooltipVisible').closest('.td-hover').attr('aria-expanded', 'false');
      $('.tooltipVisible').closest('.td-hover').trigger('focus');
      $('.review-show').removeClass('tooltipVisible');
      $('.review-show').css({'visibility': 'hidden', 'opacity': '0'});
    }
  });

  useEffect(()=>{
   if(reviewListData?.length ===0){
    setReviewerStatus(false)
   }
  },[reviewListData])


  const getData = (url) => {
    let params=url !==undefined ?`?status=${url}`:"";
    setLoader(true)
    setReviewerStatus(false)
    var openCount = 0;
    var notStarted = 0;
    var completed = 0;
    var editCount = 0;
    var commentCount = 0;
    getAxiosResponse(APIUrls.CAMPAIGN_REVIEW_LIST(workspaceId)+params)
      .then((res) => {
        if (res?.data?.status === "success") {

           var review =  res?.data?.data;
           setUpdateTime(review['updateTime']);
           delete review['updateTime']
          Object.keys(review).map(
            (item, i) => ( () => 
              (openCount =
                  openCount + res?.data?.data[item]?.resource?.openedReviewers?.length),
                (notStarted =
                  notStarted +
                  res?.data?.data[item]?.resource?.notStartedReviewers?.length),
                (completed =
                  completed +
                  res?.data?.data[item]?.resource?.completedReviewers?.length),
                (editCount = editCount + res?.data?.data[item]?.resource?.editCount),
                (commentCount =
                  commentCount + res?.data?.data[item]?.resource?.commentCount)
            )
          );
          if(review){
            setOpenReviewerCount(Object.values(review)?.map(data=>data?.resource?.openedReviewers)?.flat().length);
            setReviewListData(alphabeticalSortingLanguage(review));
            setReviewerStatus(true)
          }else{
            setOpenReviewerCount(0)
          }
          setNotStartedReviewerCount(notStarted);
          setCompletedReviewerCount(completed);
          setEditCount(editCount);
          setCommentCount(commentCount);
          setLoader(false);
          setTimeout(() => {
            $('.td-hover').on('click keydown', function(e){
              const reviewShowElem = $(this).find('.review-show');
              if (!reviewShowElem.hasClass('tooltipVisible') && (e.type === 'click' || e.key === Constants.ENTER)) {
                if ($('.tooltipVisible').length) {
                  $('.tooltipVisible').closest('.td-hover').attr('aria-expanded', 'false');
                  $('.tooltipVisible').css({'visibility': 'hidden','opacity': '0'})
                  $('.tooltipVisible').removeClass('tooltipVisible');
                }
                $(this).attr('aria-expanded', 'true');
                reviewShowElem.addClass('tooltipVisible');
                reviewShowElem.css({'visibility': 'visible','opacity': '1'});
                $('.tooltipVisible').on('keydown', function(e){
                    if (e.key === Constants.ESCAPE) {
                      $(this).closest('.td-hover').attr('aria-expanded', 'false');
                      $(this).closest('.td-hover').trigger('focus');
                      $(this).removeClass('tooltipVisible');
                      $(this).css({'visibility': 'hidden','opacity': '0'})
                    }
                });

              } else if ((e.key === Constants.TAB && e.shiftKey && $('.tooltipVisible').closest('.td-hover').is(':focus')) ||
                (e.key === Constants.TAB && e.shiftKey && $('.tooltipVisible li:first-child a').is(':focus')) ||
                e.key === Constants.ESCAPE || e.type === 'click' || e.key === Constants.ENTER) {
                  $(this).attr('aria-expanded', 'false');
                  reviewShowElem.removeClass('tooltipVisible');
                  reviewShowElem.css({'visibility': 'hidden','opacity': '0'})
              } else if (e.key === Constants.TAB && reviewShowElem.hasClass('tooltipVisible')
              && reviewShowElem.find('ul').length === 0) {
                $(this).attr('aria-expanded', 'false');
                reviewShowElem.removeClass('tooltipVisible');
                reviewShowElem.css({'visibility': 'hidden','opacity': '0'})
              } else if (e.type === 'click' && reviewShowElem.hasClass('tooltipVisible')) {
                $(this).attr('aria-expanded', 'false');
                reviewShowElem.removeClass('tooltipVisible');
                reviewShowElem.css({'visibility': 'hidden','opacity': '0'})
              }
            });

            $('.td-hover .review-show li:last-child a').on('keydown', function(e){
              if ($(this).is(':focus') && !e.shiftKey) {
                if ($(this).closest('.review-show').hasClass('tooltipVisible') && e.key === Constants.TAB) {
                  e.preventDefault();
                  $(this).closest('.td-hover').attr('aria-expanded', 'false');
                  $(this).closest('.review-show').removeClass('tooltipVisible');
                  $(this).closest('.review-show').css({'visibility': 'hidden', 'opacity': '0'});
                  $(this).closest('.td-hover').trigger('focus');
                }
              }
            });
            
          }, 300);
        }
      })
      .catch((err) => {
        handleError(err);
      });

    getAxiosResponse(APIUrls.CAMPAIGN_REVIEW_OVERVIEW(workspaceId))
      .then((res) => {
        if (res.data !== "") {
          setOverviewData(res.data.data);
        }
      })
      .catch((err) => {
        handleError(err);
      });
  }
  useEffect(() => {
    getData();
  }, []);

  return (
    <div className="listing-content">
      <div className="campaign_details-review">
        <div className="review-heading">
          <div className="heading-left">
           {translate("campaign_page.last_updated")}{" "}
            {latestUpdateTime ? latestUpdateTime.dateWithTime : ""} 
             
            <button onClick={()=>refreshPage()}>{translate("campaign_page.reset_list")}</button>
          </div>
          <div className="heading-right">
            <button className="dashboard-btn" onClick={downloadReport}>{translate("campaign_page.reviewer_status_report")}</button>
          </div>
        </div>

        {loader ? (
          <div style={{textAlign:"center"}}>
          <RotatingLines
            strokeColor="grey"
            strokeWidth="5"
            width="96"
            visible={true}
          />
          </div>
        ) : (
          <div className="review-content flex">
            <div className="review-action">
              <div className="lang-head">
                <h5>Languages</h5>
                <div className="lang-details">
                  <div className="lang-details-inner hover" onClick={()=>getData("NOT_STARTED")}>
                    <span>
                      {overViewData.languageOverview?.notStartedLanguages}
                    </span>
                    <p>{translate("campaign_page.not_started")}</p>
                  </div>
                  <div className="lang-details-inner hover" onClick={()=>getData("OPENED")}>
                    <span>
                      {overViewData.languageOverview?.openedLanguages}
                    </span>
                    <p>{translate("campaign_page.opened")}</p>
                  </div>
                  <div className="lang-details-inner hover" onClick={()=>getData("COMPLETED")}>
                    <span>
                      {overViewData.languageOverview?.completedLanguages}
                    </span>
                    <p>{translate("campaign_page.completed")}</p>
                  </div>
                </div>
              </div>
              <table className="lang-table first-left hover" aria-label="Languages">
                  <tr>
                    <th scope="col">{translate("campaign_page.languages")}</th>
                    <th scope="col">{translate("campaign_page.open_projects")}</th>
                  </tr>
                <tbody>
                  {reviewListData && Object.keys(reviewListData) &&
                  Object.keys(reviewListData)?.length !== 0 ?
                  Object.keys(reviewListData).map((item, i) => (
                    <tr key={i} className="report">
                      <td>{reviewListData[item].displayName[0]?.display}</td>
                      <td
                        className="td-hover"
                        tabIndex={
                          reviewListData[item]?.resource?.openProjects?.length > 0
                            ? "0"
                            : ""
                        }
                        aria-expanded={
                          reviewListData[item]?.resource?.openProjects?.length > 0
                            ? "false"
                            : ""
                        }
                        style={{ cursor: !reviewListData[item]?.resource?.openProjects?.length && 'default' }}
                      >
                        {" "}
                        <div
                          className={
                            reviewListData[item]?.resource?.openProjects?.length > 0
                              ? "td-text"
                              : "td-text"
                          }
                        >
                         <div className="review-circle"> {reviewListData[item]?.resource?.openProjects?.length}</div>

                          {reviewListData[item]?.resource?.openProjects?.length >
                          0 ? (
                            <div className="review-show">
                              <ul>
                                {reviewListData[item]?.resource?.openProjects.map(
                                  (project, index) => {
                                    return (
                                      <li key={index}>
                                        <Link to={`/project/${project.id}`}>{project.name}</Link>
                                        <p>{project.userGroup.name}</p>
                                      </li>
                                    );
                                  }
                                )}
                              </ul>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </td>
                    </tr>
                  )):''}
                </tbody>
              </table>
            </div>
            <div className="review-action">
              <div className="review-head">
                <h5>Reviewers</h5>
                <div className="lang-details">
                  <div className="lang-details-inner hover">
                    <span>{totalNotStartedReviewerCount}</span>
                    <p>{translate("campaign_page.not_started")}</p>
                  </div>
                  <div className="lang-details-inner hover">
                    <span>{totalOpenReviewerCount}</span>
                    <p>{translate("campaign_page.opened")}</p>
                  </div>
                  <div className="lang-details-inner hover">
                    <span>{totalCompletedReviewerCount}</span>
                    <p>{translate("campaign_page.completed")}</p>
                  </div>
                </div>
              </div>
              <table className="lang-table" aria-label="Reviewers">
                <tr>
                  <th scope="col">{translate("campaign_page.not_started")}</th>
                  <th scope="col">{translate("campaign_page.open")}</th>
                  <th scope="col">{translate("campaign_page.completed")}</th>
                </tr>
                <tbody>
                  {
                  reviewListData.length !== 0 ?
                  Object.keys(reviewListData).map((item, i) => (
                    <tr key={i} className="report">
                      <td
                        className="td-hover"
                        tabIndex={reviewListData[item]?.resource?.notStartedReviewers?.length?0:""}
                        style={{ cursor: !reviewListData[item]?.resource?.notStartedReviewers?.length && 'default' }}
                      >
                        {" "}
                        <div
                          className={
                            reviewListData[item]?.resource?.notStartedReviewers
                              .length > 0
                              ? "td-text"
                              : "td-text"
                          }
                        >
                          <div className="review-circle">{
                            reviewListData[item]?.resource?.notStartedReviewers
                              ?.length
                          }</div>
                          {reviewListData[item]?.resource?.notStartedReviewers
                            .length > 0 ? (
                              <div className="review-show">
                               <ul >
                              {reviewListData[item]?.resource?.notStartedReviewers?.map((data,index)=>(
                               
                               <li key={index}>
                                <p>
                                {data?.user?.firstName +
                                  " " +
                                  data?.user?.lastName}{" "}
                                 {" "}
                                </p>
                                <span>
                                  {
                                    data?.notStartedAssets
                                  }{" "}
                                  Asset(s)
                                </span>
                              </li>))}
                              </ul>
                              </div>
                              
                          ) : (
                            ""
                          )}
                        </div>
                      </td>
                      <td
                        className="td-hover"
                        tabIndex={reviewListData[item]?.resource.openedReviewers.length?0:''}
                        style={{ cursor: !reviewListData[item]?.resource?.openedReviewers.length && 'default' }}
                      >
                        {" "}
                        <span
                          className="td-text"
                        >
                          <div className="review-circle">{reviewListData[item]?.resource?.openedReviewers.length}</div>
                          {reviewListData[item]?.resource?.openedReviewers.length >
                          0 ? (
                            <div className="review-show">
                              <ul >
                            {reviewListData[item]?.resource?.openedReviewers?.map((data,index)=>(
                              
                              <li key={index}>
                           <p >
                             {data
                               ?.user?.firstName +
                               " " +
                               data
                                 ?.user?.lastName}{" "}
                           </p>
                           <span>
                               {(data
                                 ?.openedAssets + data
                                 ?.completedAssets) +
                                 " of " +
                                 data?.total 
                                 } 
                             </span>
                             <span> Asset(s) Opened</span>
                           </li>))}
                           </ul>
                           </div>
                          ) : (
                            ""
                          )}
                        </span>
                      </td>
                      <td
                        className="td-hover"
                        tabIndex={reviewListData[item].resource.completedReviewers.length?0:''}
                        style={{ cursor: !reviewListData[item].resource.completedReviewers.length && 'default' }}
                      >
                        {" "}
                        <span
                          className="td-text"
                        >
                          <div className="review-circle">{
                            reviewListData[item].resource.completedReviewers
                              .length
                          }</div>
                          {reviewListData[item].resource.completedReviewers
                            .length > 0 ? (
                              <div className="review-show">
                                <ul>
                                  {reviewListData[item].resource
                                .completedReviewers.map((data,index)=>(
                                   <li key={index}>
                            <p >
                              {data?.user?.firstName +
                                " " +
                                data?.user?.lastName}{" "}
                            <p>{data?.total} Asset(s)</p>
                            </p>
                                                       </li>
                                ))}
                                  
                                                       </ul>
                                                       </div>
                          ) : (
                            ""
                          )}
                        </span>
                      </td>
                    </tr>
                  )):''}
                </tbody>
              </table>
            </div>
            <div className="review-action">
              <div className="review-head">
                <h5>Actions</h5>
                <div className="lang-details">
                  <div className="lang-details-inner hover">
                    <span>{totalCommentCount}</span>
                    <p>{translate("campaign_page.comments")}</p>

                  </div>
                  <div className="lang-details-inner hover">
                  <span>{totalEditCount}</span>
                    <p>{translate("campaign_page.edits")}</p>

                  </div>
                </div>
              </div>
              <table className="lang-table" aria-label="Actions">
                <tr>
                <th scope="col">{translate("campaign_page.comments")}</th>
                  <th scope="col" className="text-center">{translate("campaign_page.edits")}</th>
                </tr>
                <tbody>
                  {
                    reviewListData.length !== 0 ?
                  Object.keys(reviewListData).map((item, i) => (
                    <tr key={i} className="report">
                      <td>{reviewListData[item].resource.commentCount}</td>
                      <td>{reviewListData[item].resource.editCount}</td>
                    </tr>
                  )):''}
                </tbody>
              </table>
            </div>
          
          </div>
          
        )}
          {reviewerStatus && reviewListData && Object.keys(reviewListData) && Object.keys(reviewListData).length  < 1 && 
          <div className="review-content">
            <div className="review-action"></div>
            <span>There are no languages that fit the specified category.</span>
          </div>
          }
            
      </div>
    </div>
  );
}
